const generateCode = () => (Math.random().toString() + '0000').substr(2, 4);

const verifyCode = (codeToVerify, code) => {
  const message = 'Please try again.';

  if (codeToVerify !== code)
    return {
      variant: 'error',
      message: `Confirmation Code did not match. ${message}`,
    };

  return {
    variant: 'success',
    message: 'Confirmation Code matched.',
  };
};

export { generateCode, verifyCode };
